<template>
  <Button
    v-if="canDelete()"
    :icon="getIcon()"
    severity="danger"
    class="rounded-full!"
    :class="getSize()"
    @click="performDelete()"
    aria-label="Delete"
  ></Button>
</template>

<script setup lang="ts">
import { useConfirm } from "primevue/useconfirm";

const props = defineProps(["params"]);
const confirm = useConfirm();

const canDelete = (): boolean => {
  if (props.params.checkDeletable != null) return props.params.checkDeletable(props.params.data);
  return true;
};

const getIcon = (): string => {
  let icon = "pi pi-times ";
  if (props.params.size && props.params.size.toUpperCase() === "SMALL") return icon + "text-xs";
  else return icon + "text-base";
};

const getSize = (): string => {
  if (props.params.size && props.params.size.toUpperCase() === "SMALL") return "w-5! h-5! p-1! mb-1!";
  else return "w-7! h-7! p-2! mb-2!";
};

const performDelete = (): void => {
  confirmPopup(
    confirm,
    props.params.deleteConfirmHeader(props.params.data),
    props.params.deleteConfirmMessage(props.params.data),
    () => props.params.callback(props.params.data),
    () => info("Delete Cancelled", "")
  );
};
</script>
